// Shared helper: checks whether a user has uploaded + been verified on all
// required KYC documents (Aadhaar front/back, driving license).
// Used after a booking's payment succeeds (cash or PayU) to decide whether
// to route the user to document verification or straight to My Bookings.

export const checkUserDocuments = async (userId) => {
  try {
    if (!userId) {
      console.warn('⚠️ No user ID found for document check');
      return false;
    }

    console.log('📄 Checking documents for user:', userId);

    const token =
      localStorage.getItem('token') ||
      localStorage.getItem('auth_token') ||
      localStorage.getItem('authToken');

    const response = await fetch(
      `${import.meta.env.VITE_BASE_URL}/api/documents/userdocuments/${userId}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      if (response.status === 404) {
        console.log('📄 No documents found for user');
        return false;
      }
      throw new Error(`HTTP ${response.status}`);
    }

    const docs = await response.json();

    const hasAadhaarFront = !!docs?.adhaarFrontImageUrl;
    const hasAadhaarBack = !!docs?.adhaarBackImageUrl;
    const hasLicense = !!docs?.drivingLicenseImageUrl;
    const hasAllDocuments = hasAadhaarFront && hasAadhaarBack && hasLicense;

    const isFrontVerified = docs?.adhaarFrontStatus === 'VERIFIED';
    const isBackVerified = docs?.adhaarBackStatus === 'VERIFIED';
    const isLicenseVerified = docs?.licenseStatus === 'VERIFIED';
    const allVerified = isFrontVerified && isBackVerified && isLicenseVerified;

    return hasAllDocuments && allVerified;
  } catch (error) {
    console.error('❌ Error checking documents:', error);
    return false;
  }
};

export const getCurrentUserId = (user) => user?.data?.id || user?.id || user?.userId;
